import { HubConnection } from "@microsoft/signalr"

export type HubEventHandler<THubContract> = {
  [K in keyof THubContract]: (payload: NonNullable<THubContract[K]>) => void
}

export function registerHubHandlers<THubContract extends object>(
  connection: HubConnection,
  handlers: HubEventHandler<THubContract>
): void {
  ;(Object.keys(handlers) as (keyof THubContract)[]).forEach((eventName) => {
    // eslint-disable-next-line security/detect-object-injection
    connection.on(eventName as string, handlers[eventName])
  })
}
